import SingleButtonPublish from './SingleButtonPublish';

export default SingleButtonPublish;
